import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createSlots as _createSlots, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9698dc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CustomerChannelStatistics" }
const _hoisted_2 = { class: "statistics" }
const _hoisted_3 = {
  key: 0,
  class: "table-tools"
}
const _hoisted_4 = { class: "column-summary" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "勾选需要在列表中显示的字段", -1))
const _hoisted_6 = { class: "column-sections" }
const _hoisted_7 = { class: "column-section" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column-section-title" }, [
  /*#__PURE__*/_createTextVNode("基础字段 "),
  /*#__PURE__*/_createElementVNode("span", null, "默认显示")
], -1))
const _hoisted_9 = { class: "column-section" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column-section-title" }, [
  /*#__PURE__*/_createTextVNode("扩展统计字段 "),
  /*#__PURE__*/_createElementVNode("span", null, "按需添加")
], -1))
const _hoisted_11 = { class: "column-footer" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig, extendedColumns} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {usePermission} from '@/hooks/usePermission'
import {useStore} from "@/store";
import {initEmptyParam} from "@/hooks/useInitParam";
import dayjs from 'dayjs'
import {downloadData, getListData} from "@/service/main/system";
import {computed, onBeforeUnmount, ref} from "vue";
import {queryDrainageSummaryStatistics} from "@/service/main/live/statitiscal";
import {modalConfig} from './config/modal.config'
import PageModal from "@/components/PageModal.vue";
import localCache from '@/utils/cache';
import {ElLoading, ElMessage, ElMessageBox} from "element-plus";

const columnCacheKey = 'customerChannelStatistics.visibleColumns'

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerChannelStatistics',
  setup(__props) {

initEmptyParam()
const store = useStore()
const canViewExtendedStatistics = usePermission('customerChannelStatistics', 'extendedStatistics')

const allColumns = [...contentTableConfig.propList, ...extendedColumns]
const defaultColumns = contentTableConfig.propList.map(column => column.prop)
const savedColumns = localCache.getCache(columnCacheKey)
const visibleColumns = ref<string[]>(Array.isArray(savedColumns)
  ? savedColumns.filter(prop => allColumns.some(column => column.prop === prop))
  : [...defaultColumns])
const columnDialogVisible = ref(false)
const draftColumns = ref<string[]>([])
const tableConfig = computed(() => ({
  ...contentTableConfig,
  propList: allColumns.filter(column => visibleColumns.value.includes(column.prop))
}))
const openColumnDialog = () => {
  draftColumns.value = [...visibleColumns.value]
  columnDialogVisible.value = true
}
const saveColumns = () => {
  if (draftColumns.value.length === 0) {
    ElMessage.warning('请至少选择一列')
    return
  }
  try {
    localCache.setCache(columnCacheKey, draftColumns.value)
    visibleColumns.value = [...draftColumns.value]
    columnDialogVisible.value = false
  } catch {
    ElMessage.error('列配置保存失败，请检查浏览器存储权限')
  }
}

const extensionStatus = ref('')
const queryId = ref('')
const extendedLoading = ref(false)
const listLoading = ref(true)
let currentQuery: any = {}
let listVersion = 0
let currentPage = { pageNo: 1, pageSize: 10 }
const updateExtensionStatus = (data: any) => {
  extensionStatus.value = data.extensionStatus
  queryId.value = data.queryId
}
const loadChannelPage = async (params: any, fromExtendedButton = false) => {
  const version = ++listVersion
  extensionStatus.value = ''
  queryId.value = ''
  listLoading.value = true
  if (!fromExtendedButton) extendedLoading.value = false
  currentQuery = { ...params }
  currentPage = { pageNo: params.pageNo, pageSize: params.pageSize }
  store.commit('system/changeCustomerChannelStatisticsList', [])
  store.commit('system/changeCustomerChannelStatisticsCount', 0)
  try {
    const data = await getListData('/main/customerChannelStatistics/queryByCondition', params)
    if (version !== listVersion) return
    // 原列表只显示基础数据，扩展字段由用户点击后加载。
    const rows = data.list.map((row: any) => {
      const baseRow = { ...row }
      extendedColumns.forEach(({ prop }) => {
        delete baseRow[prop]
        delete baseRow[`${prop}Str`]
      })
      return baseRow
    })
    store.commit('system/changeCustomerChannelStatisticsList', rows)
    store.commit('system/changeCustomerChannelStatisticsCount', Number(data.total))
    updateExtensionStatus(data)
  } finally {
    if (version === listVersion) listLoading.value = false
  }
}
const loadExtendedResult = async () => {
  if (listLoading.value || extendedLoading.value) return
  let version = listVersion
  extendedLoading.value = true
  try {
    if (extensionStatus.value !== 'READY') {
      version = listVersion + 1
      await loadChannelPage(currentQuery, true)
      if (version !== listVersion) return
      if (extensionStatus.value !== 'READY') {
        await ElMessageBox.alert('数据正在加载，请稍后再试。', '提示', { confirmButtonText: '知道了', showClose: false, closeOnPressEscape: false })
        return
      }
    }
    if (!queryId.value) {
      ElMessage.error('扩展统计查询 ID 缺失，请重新查询列表')
      return
    }
    const data = await getListData('/main/customerChannelStatistics/queryExtendedResult', {
      queryId: queryId.value,
      ...currentPage
    })
    if (version !== listVersion) return
    updateExtensionStatus(data)
    if (data.extensionStatus === 'READY') {
      // 接口返回当前页的完整统计行，直接使用同一 queryId 的结果，避免按数组下标拼接。
      store.commit('system/changeCustomerChannelStatisticsList', data.list)
      store.commit('system/changeCustomerChannelStatisticsCount', Number(data.total))
    } else {
      await ElMessageBox.alert('数据正在加载，请稍后再试。', '提示', { confirmButtonText: '知道了', showClose: false, closeOnPressEscape: false })
    }
  } finally {
    if (version === listVersion) extendedLoading.value = false
  }
}
const formatExtendedValue = (row: any, prop: string) => {
  if (prop.endsWith('Rate')) {
    const text = row[`${prop}Str`]
    if (text !== null && text !== undefined && text !== '') return text
    const value = row[prop]
    return value === null || value === undefined || value === '' ? '' : `${value}%`
  }
  return row[prop] ?? ''
}
onBeforeUnmount(() => { listVersion++ })

const getChannelList = async () => {
  let channelData = await getListData('/main/customerChannel/queryAllChannel', {})
  const channelItem = searchFormConfig.formItems.find(item => item.field === 'channelName')
  channelItem!.options = channelData.map((item: any) => {
    return {title: item, value: item}
  })
}
getChannelList()

const getThirdPartyList = async () => {
  let thirdPartyData = await getListData('/main/customerChannel/queryThirdParty', {})
  const thirdPartyItem = searchFormConfig.formItems.find((item) => item.field === 'thirdParty')
  thirdPartyItem!.options = thirdPartyData.map((item: any) => {
    return {title: item, value: item}
  })
  const thirdPartyModal = modalConfig.formItems.find(item => item.field === 'thirdParty')
  thirdPartyModal!.options = thirdPartyData.map((item: any) => {
    return {title: item, value: item}
  })
}
getThirdPartyList()

const queryParam = {
  cfddFlag: false,
  forceRefresh: false,
  timeSlot: [
    dayjs().startOf('date').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
  ],
  pageNo: 1,
  pageSize: 10
}
store.commit('system/changeQueyryInfo', queryParam)

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const resetCb = () => {
  getStatistics(queryParam)
  return queryParam
}
const statistics = ref({
  resourcesCount: '--',
  repeatRate: '--',
  deleteRate: '--',
  totalDeleteRate: '--',
  invalidNum: '--',
  thCount: '--',
  // notPreciseCount: '--',
  openRate: '--',
  lookRate: '--',
  dealCount: '--',
  monthConversionRate: '--',
  lastMonthConversionRate: '--',
  accConversionRate: '--'
})

const getStatistics = async (item: any) => {
  statistics.value = await queryDrainageSummaryStatistics(item)
}
getStatistics(queryParam)

const searchCb = async (item: any) => {
  statistics.value = {
    resourcesCount: '--',
    repeatRate: '--',
    deleteRate: '--',
    totalDeleteRate: '--',
    invalidNum: '--',
    thCount: '--',
    // notPreciseCount: '--',
    openRate: '--',
    lookRate: '--',
    dealCount: '--',
    monthConversionRate: '--',
    lastMonthConversionRate: '--',
    accConversionRate: '--'
  }
  await getStatistics(item)
}

const defaultInfo = ref({})
const pageModalRef = ref<InstanceType<typeof PageModal>>()
const modalTitle = ref('统计条件')
const handleDailyExportClick = () => {
  pageModalRef.value.dialogVisible = true
  pageModalRef.value.isBatch = true
}

const handleSubmitClick = async (formData: any) => {
  try {
    const loadingInstance = ElLoading.service({
      lock: true,
      text: '数据下载中...',
      background: 'rgba(0,0,0,0.5)'
    });
    await downloadData(
      '/main/drainageStatistics/exportDaily',
      {
        ...formData
      },
      'blob'
    ).then((res) => {
      loadingInstance.close()
      const blob = new Blob([res], {
        type: 'application/octet-stream'
      })
      const down = document.createElement('a')
      down.download = '每日数据统计.xlsx'
      down.style.display = 'none'
      down.href = URL.createObjectURL(blob)
      document.body.appendChild(down)
      down.click()
      URL.revokeObjectURL(down.href)
      document.body.removeChild(down)
    })
    pageModalRef.value.dialogVisible = false
    pageContentRef.value?.getPageData(store.state.system.queryInfo)
  } finally {
    pageModalRef.value.confirmLoading = false
  }
}

const importAction = process.env.VUE_APP_BASE_URL + '/main/changeChannelStatistics/costResourceImport'
const importHeaders = ref({
  Authorization: `Bearer ${localCache.getCache('token')}`
})
let importLoadingInstance: any = null
const handleCostResourceImportProgress = () => {
  importLoadingInstance = ElLoading.service({
    lock: true,
    text: '导入中...',
    background: 'rgba(0,0,0,0.5)'
  })
}
const handleCostResourceImportSuccess = async (response: any) => {
  if (importLoadingInstance && typeof importLoadingInstance.close === 'function') {
    importLoadingInstance.close()
  }
  if (response?.code === 200) {
    ElMessage.success(response?.data || response?.message || '导入成功')
    pageContentRef.value?.getPageData(store.state.system.queryInfo)
    await getStatistics(store.state.system.queryInfo)
  } else {
    ElMessage.error(response?.message || '导入失败')
  }
}
const handleCostResourceImportError = () => {
  if (importLoadingInstance && typeof importLoadingInstance.close === 'function') {
    importLoadingInstance.close()
  }
  ElMessage.error('导入失败')
}
const [pageContentRef, handleResetClick, handleSearchClick, handleDownBtnClick] = usePageSearch(resetCb, searchCb)
const lastForceRefresh = ref(queryParam.forceRefresh)
const handleSearchFormChange = (formData: any) => {
  const forceRefresh = formData.forceRefresh === true
  if (forceRefresh && !lastForceRefresh.value) {
    handleSearchClick(formData)
  }
  lastForceRefresh.value = forceRefresh
}

let importLoading: ReturnType<typeof ElLoading.service> | null = null
const closeImportLoading = () => {
  if (importLoading && typeof importLoading.close === 'function') {
    importLoading.close()
  }
  importLoading = null
}

const handleImportProgress = () => {
  importLoading = ElLoading.service({
    lock: true,
    text: '导入数据中...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

const handleImportSuccess = (res: any) => {
  closeImportLoading()
  if (Array.isArray(res) && res.length > 0) {
    const errs = res.map((item: any) => item.reason).join(',')
    ElMessage({
      type: 'error',
      duration: 0,
      showClose: true,
      message: '导入存在异常数据如下：' + errs
    })
    return
  }
  const code = res?.code
  if (code !== undefined && code !== null && Number(code) !== 0 && Number(code) !== 200) {
    ElMessage({
      type: 'warning',
      message: res.message || '导入失败'
    })
    return
  }
  ElMessage({
    type: 'success',
    message: '导入成功'
  })
  const queryInfo = { ...store.state.system.queryInfo }
  getStatistics(queryInfo)
  pageContentRef.value?.getPageData(queryInfo)
}

const handleImportError = (res: any) => {
  closeImportLoading()
  ElMessage({
    type: 'error',
    message: res?.message || '导入失败'
  })
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick),
      onChange: handleSearchFormChange
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createTextVNode("资源数: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.resourcesCount), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("重复率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.repeatRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("24小时删除率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.deleteRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("累计删除率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.totalDeleteRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("重叠数: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.invalidNum), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("同行数: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.thCount), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("开口率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.openRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("看课率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.lookRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("成交资源数: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.dealCount), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("当月转化率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.monthConversionRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("上月转化率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.lastMonthConversionRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("累积转化率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.accConversionRate) + "%", 1)
      ])
    ]),
    (_unref(canViewExtendedStatistics))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            size: "medium",
            icon: "el-icon-data-analysis",
            disabled: listLoading.value,
            loading: extendedLoading.value,
            onClick: loadExtendedResult
          }, {
            default: _withCtx(() => [
              _createTextVNode("获取扩展统计")
            ]),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createVNode(_component_el_button, {
            size: "medium",
            icon: "el-icon-setting",
            onClick: openColumnDialog
          }, {
            default: _withCtx(() => [
              _createTextVNode("自定义列")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: tableConfig.value,
      loadPage: loadChannelPage,
      pageName: "customerChannelStatistics",
      downFilename: "渠道资源相关数据统计.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick),
      onDailyExportClick: handleDailyExportClick,
      onImportProgress: handleImportProgress,
      onImportSuccess: handleImportSuccess,
      onImportError: handleImportError,
      onSortChange: handleSortChange
    }, _createSlots({
      headerHandler: _withCtx(() => [
        _createVNode(_component_el_upload, {
          class: "cost-resource-import",
          action: importAction,
          headers: importHeaders.value,
          accept: ".xls,.xlsx",
          "show-file-list": false,
          "on-progress": handleCostResourceImportProgress,
          "on-success": handleCostResourceImportSuccess,
          "on-error": handleCostResourceImportError
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              size: "medium",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("导入产出数据")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["headers"])
      ]),
      repeatRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.repeatRate) + "%", 1)
      ]),
      deleteRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.deleteRate) + "%", 1)
      ]),
      totalDeleteRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.totalDeleteRate) + "%", 1)
      ]),
      openRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.openRate) + "%", 1)
      ]),
      lookRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.lookRate) + "%", 1)
      ]),
      roiRatio: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.roiRatioStr || scope.row.roiRatio || '0.0000'), 1)
      ]),
      monthConversionRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.monthConversionRate) + "%", 1)
      ]),
      lastMonthConversionRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.lastMonthConversionRate) + "%", 1)
      ]),
      accConversionRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.accConversionRate) + "%", 1)
      ]),
      _: 2
    }, [
      _renderList(_unref(extendedColumns), (column) => {
        return {
          name: column.slotName,
          fn: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(formatExtendedValue(scope.row, column.prop)), 1)
          ])
        }
      })
    ]), 1032, ["contentTableConfig", "onDownBtnClick"]),
    _createVNode(_component_el_dialog, {
      modelValue: columnDialogVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((columnDialogVisible).value = $event)),
      title: "自定义列",
      width: "720px",
      top: "8vh",
      "custom-class": "channel-column-dialog"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_button, {
            type: "text",
            icon: "el-icon-refresh-left",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (draftColumns.value = [..._unref(defaultColumns)]))
          }, {
            default: _withCtx(() => [
              _createTextVNode("恢复默认")
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (columnDialogVisible.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: saveColumns
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", null, [
            _createTextVNode("已选 "),
            _createElementVNode("strong", null, _toDisplayString(draftColumns.value.length), 1),
            _createTextVNode(" / " + _toDisplayString(allColumns.length) + " 项", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("section", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_checkbox_group, {
              modelValue: draftColumns.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((draftColumns).value = $event)),
              class: "column-options"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contentTableConfig).propList, (column) => {
                  return (_openBlock(), _createBlock(_component_el_checkbox, {
                    key: column.prop,
                    label: column.prop
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(column.label) + _toDisplayString(column.prop === 'dealCount' ? '（按创建时间）' : column.prop === 'succTimeDealCount' ? '（按成交时间）' : ''), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("section", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_checkbox_group, {
              modelValue: draftColumns.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((draftColumns).value = $event)),
              class: "column-options"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(extendedColumns), (column) => {
                  return (_openBlock(), _createBlock(_component_el_checkbox, {
                    key: column.prop,
                    label: column.prop
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(column.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: defaultInfo.value,
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "drainageStatistics",
      onUpdateBatchData: handleSubmitClick
    }, null, 8, ["defaultInfo", "modalConfig", "title"])
  ]))
}
}

})